<template>
    <v-menu 
        ref="menu"
        v-model="menu" 
        :close-on-content-click="false" 
        :return-value.sync="dates" 
        transition="scale-transition" 
        offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                solo
                dense
                readonly
                v-on="on"
                v-bind="attrs"
                v-model="dateRangeText"
                prepend-inner-icon="mdi-calendar"
                :label="$t('components.DateRangePicker.PlaceholderLabel')"
                :loading="loading"
                :append-icon="dates.length ? 'mdi-close-circle' : ''"
                @click:append="clear"/>
        </template>

        <v-date-picker 
            range 
            no-title 
            scrollable
            v-model="dates" 
            :locale="$i18n.locale"
            :allowed-dates="validDates"
            :first-day-of-week="$i18n.locale == 'es' ? 1 : 0">
            <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
            <v-btn text color="primary" @click="submit">OK</v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>

/**
 * DateRangePicker component allows to user to filter de whole dashboard 
 * visualizations data by a range of dates. Its only a visual component that 
 * emits the user dates selection to the parent component.
 */
export default {
    name: 'DateRangePicker',
    props: {
        loading: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        dates: [],
        menu: false
    }),
    computed: {
        dateRangeText() {
            return this.dates && this.dates.length ? this.dates.join('  ~  ') : '';
        }
    },
    methods: {
        validDates(value) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return new Date(value) < today;
        }, 
        submit() {
            this.$refs.menu.save(this.dates);
            let res = this.dates.map(d => new Date(d));

            if (res.length > 1 && res[0] > res[1]) res = [ res[1], res[0] ];
            else if (res.length == 1) {
                let d = new Date(res[0]);
                res[0] = d.setHours(0, 0, 0, 0);
                res[1] = d.setHours(23,59,59,999);
            }

            this.$emit('selected', res);
        },
        clear() {
            this.dates = [];
            this.$emit('cleared');
        }
    }
}
</script>